import type {
  BlockScopedPostTarget,
  LearnerInfo,
  OptimisticThreadLike,
  PendingPostLike,
  ThreadItem,
  ThreadWithPostTarget,
} from "./types";

type PostRef = {
  uid?: string | null;
  title?: string | null;
} | null;

type ThreadLike =
  | {
      classPost?: PostRef;
      learningAssignmentClassPost?: PostRef;
    }
  | null
  | undefined;

export type PostTarget = BlockScopedPostTarget;

export function postTargetFromPendingPost(
  pendingPost: PendingPostLike,
): PostTarget {
  return pendingPost.postType === "classPost"
    ? { classPostUid: pendingPost.postUid }
    : { learningAssignmentClassPostUid: pendingPost.postUid };
}

export function postTargetFromThread(
  thread: ThreadWithPostTarget | null | undefined,
): PostTarget {
  if (thread?.classPost?.uid) {
    return { classPostUid: thread.classPost.uid };
  }
  if (thread?.learningAssignmentClassPost?.uid) {
    return {
      learningAssignmentClassPostUid: thread.learningAssignmentClassPost.uid,
    };
  }
  return {};
}

export function isGeneralThread(thread: ThreadLike): boolean {
  return !thread?.classPost && !thread?.learningAssignmentClassPost;
}

export function getThreadPostTitle(thread: ThreadLike): string | null {
  return (
    thread?.classPost?.title ??
    thread?.learningAssignmentClassPost?.title ??
    null
  );
}

export function getPostTarget(target: PostTarget): PostTarget {
  if (target.classPostUid) {
    return { classPostUid: target.classPostUid };
  }
  if (target.learningAssignmentClassPostUid) {
    return {
      learningAssignmentClassPostUid: target.learningAssignmentClassPostUid,
    };
  }
  return {};
}

export function getThreadPostTarget(thread: ThreadLike): PostTarget {
  if (thread?.classPost?.uid) {
    return { classPostUid: thread.classPost.uid };
  }
  if (thread?.learningAssignmentClassPost?.uid) {
    return {
      learningAssignmentClassPostUid: thread.learningAssignmentClassPost.uid,
    };
  }
  return {};
}

export function postTitleFromThreadOrOptimistic(
  thread: ThreadItem | null | undefined,
  optimisticThread?: OptimisticThreadLike | null,
): string | undefined {
  const optimisticPostTitle =
    optimisticThread && "postTitle" in optimisticThread.pendingPost
      ? optimisticThread.pendingPost.postTitle
      : undefined;

  return getThreadPostTitle(thread) ?? optimisticPostTitle ?? undefined;
}

export function learnerSenderFromLearner(learner: LearnerInfo) {
  return {
    uid: learner.uid,
    name: learner.name ?? "",
    photo: null,
    isLearner: true as const,
  };
}

export const buildLearnerSender = learnerSenderFromLearner;
